import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import Button from "components/button/Button";
import Pagination from "components/common/Pagination";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import { compose } from "redux";
import { connect } from "react-redux";
import Api from "api/Api";
import CommonModal from "components/common/CommonModal";
import Loader from "components/common/Loader";
import Toaster from "components/common/Toaster";

const AdminTable = props => {
  const [tblData, settblData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("DESC");
  const [field, setField] = useState("createdAt");
  const [toggle, setToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [addModal, setAddModal] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "", lastName: "", email: "", password: "", adminType: "STORE", storesId: ""
  });
  const [stores, setStores] = useState([]);
  const [formLoading, setFormLoading] = useState(false);
  const toaster = useRef();
  const { history } = props;

  const columns = [
    {
      Header: "First Name",
      accessor: "firstName",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class"
    },
    {
      Header: "Last Name",
      accessor: "lastName",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class"
    },
    {
      Header: "Email",
      accessor: "email",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class"
    },
    {
      Header: "Admin Type",
      accessor: "adminType",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      width: 120
    },
    {
      Header: "Store",
      accessor: "storeName",
      className: "text-center",
      filterable: false,
      headerClassName: "react-table-header-class",
      Cell: props => <span>{props.value || "—"}</span>
    },
    {
      Header: "Action",
      accessor: "action",
      className: "text-center",
      headerClassName: "react-table-header-class",
      sortable: false,
      filterable: false,
      width: 120,
      Cell: props => (
        <div className="react-action-class">
          <Button
            className="c-btn c-danger"
            onClick={() => {
              setToggle(!toggle);
              setdeleteId(props.original.adminId);
            }}
          >
            <div className="fs-14 medium-text">
              <i className="fas fa-trash mr-6" /> Delete
            </div>
          </Button>
        </div>
      )
    }
  ];

  useEffect(() => {
    const params = {
      page: { limit: 10, pageId: 1 },
      sortBy: { direction: "DESC", property: "createdAt" },
      search: ""
    };
    callListApi(params);
    setPages(10);
    loadStores();
  }, []);

  const callListApi = params => {
    setLoader(true);
    Api.post("/admin/adminManagement/list", params)
      .then(res => {
        settblData(res.data.data.list);
        setLoader(false);
        setPages(Math.ceil(res.data.data.totalRecords / 10));
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.message);
        setLoader(false);
      });
  };

  const loadStores = () => {
    Api.post("/admin/store/list", {
      page: { limit: 100, pageId: 1 },
      sortBy: { direction: "ASC", property: "storeName" },
      search: ""
    })
      .then(res => setStores(res.data.data.list || []))
      .catch(() => {});
  };

  const handleYes = () => {
    setLoading(true);
    Api.delete(`/admin/adminManagement/delete?adminId=${deleteId}`)
      .then(res => {
        if (toaster.current) toaster.current.success(res.data.message);
        callListApi({
          page: { limit: 10, pageId: activePage + 1 },
          search: searchText,
          sortBy: { direction: sortBy, property: field }
        });
        setLoading(false);
        setToggle(!toggle);
      })
      .catch(error => {
        setLoading(false);
        setToggle(!toggle);
        if (toaster.current) toaster.current.error(error.message);
      });
  };

  const handleAddAdmin = () => {
    setFormLoading(true);
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      password: formData.password,
      adminType: formData.adminType,
      storesId: formData.storesId ? parseInt(formData.storesId) : null
    };
    Api.post("/admin/adminManagement/add", payload)
      .then(res => {
        if (toaster.current) toaster.current.success(res.data.message);
        setAddModal(false);
        setFormData({ firstName: "", lastName: "", email: "", password: "", adminType: "STORE", storesId: "" });
        callListApi({
          page: { limit: 10, pageId: activePage + 1 },
          search: searchText,
          sortBy: { direction: sortBy, property: field }
        });
        setFormLoading(false);
      })
      .catch(error => {
        setFormLoading(false);
        if (toaster.current) toaster.current.error(error?.response?.data?.message || error.message);
      });
  };

  const addAdminForm = (
    <div className="pa-15">
      <div className="form-group">
        <label>First Name</label>
        <input type="text" className="form-control react-form-input"
          value={formData.firstName} onChange={e => setFormData({ ...formData, firstName: e.target.value })} />
      </div>
      <div className="form-group">
        <label>Last Name</label>
        <input type="text" className="form-control react-form-input"
          value={formData.lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} />
      </div>
      <div className="form-group">
        <label>Email *</label>
        <input type="email" className="form-control react-form-input"
          value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
      </div>
      <div className="form-group">
        <label>Password *</label>
        <input type="password" className="form-control react-form-input"
          value={formData.password} onChange={e => setFormData({ ...formData, password: e.target.value })} />
      </div>
      <div className="form-group">
        <label>Admin Type</label>
        <select className="form-control react-form-input"
          value={formData.adminType} onChange={e => setFormData({ ...formData, adminType: e.target.value })}>
          <option value="STORE">STORE</option>
          <option value="MASTER">MASTER</option>
        </select>
      </div>
      {formData.adminType === "STORE" && (
        <div className="form-group">
          <label>Link to Store *</label>
          <select className="form-control react-form-input"
            value={formData.storesId} onChange={e => setFormData({ ...formData, storesId: e.target.value })}>
            <option value="">Select a store...</option>
            {stores.map(s => (
              <option key={s.storeId} value={s.storeId}>{s.storeName}</option>
            ))}
          </select>
        </div>
      )}
      <div className="text-center ptb-10">
        <Button className="c-btn ma-5" onClick={handleAddAdmin}
          loading={formLoading} disabled={formLoading || !formData.email || !formData.password}
          style={{ backgroundColor: "#0f172a", color: "#fff" }} dataStyle="expand-right">
          Create Admin
        </Button>
        <Button className="c-btn c-danger ma-5" onClick={() => setAddModal(false)}>Cancel</Button>
      </div>
    </div>
  );

  return (
    <div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Admin List
            </div>
            <div className="mr-10">
              <input value={searchText}
                onChange={e => {
                  setLoader(true); setActivePage(0);
                  callListApi({ page: { limit: 10, pageId: 1 }, search: e.target.value,
                    sortBy: { direction: sortBy, property: field } });
                  setSearchText(e.target.value);
                }}
                type="text" placeholder="Search..."
                className="fs-14 medium-text plr-10 form-control react-form-input" />
            </div>
            <div>
              <Button className="c-btn ma-5" onClick={() => setAddModal(true)}
                style={{ backgroundColor: "#0f172a", color: "#fff" }}>
                <i className="fas fa-plus mr-10"></i>Add Admin
              </Button>
            </div>
          </div>
          <div className="roe-card-body">
            <ReactTable
              style={{ border: "none", boxShadow: "none" }}
              data={tblData} columns={columns} defaultPageSize={10}
              filterable minRows={2} manual
              defaultFilterMethod={(filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined
                  ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true;
              }}
              getTdProps={() => ({ style: { height: "60px" } })}
              className="-striped -highlight custom-react-table-theme-class"
              pages={pages} page={activePage}
              PaginationComponent={Pagination} loading={loader} LoadingComponent={Loader}
              onPageChange={pageIndex => {
                setActivePage(pageIndex);
                callListApi({ page: { limit: 10, pageId: pageIndex + 1 }, search: searchText,
                  sortBy: { direction: sortBy, property: field } });
              }}
              onSortedChange={sortProperties => {
                const sort = sortProperties[0].desc ? "DESC" : "ASC";
                setSortBy(sort); setActivePage(0); setField(sortProperties[0].id);
                callListApi({ page: { limit: 10, pageId: 1 }, search: searchText,
                  sortBy: { direction: sort, property: sortProperties[0].id } });
              }}
            />
          </div>
          <Toaster ref={toaster} />
          <CommonModal size="lg" modal={addModal}
            toggle={() => setAddModal(!addModal)}
            viewModalCheck={true} headerData={"Add New Admin"}
            children={addAdminForm} />
          <CommonModal modal={toggle}>
            <div className="react-table-header-class text-center ptb-18">
              Are you sure you want to delete?
            </div>
            <div className="text-center pb-15">
              <Button className="c-btn c-success mr-10 plr-30" onClick={handleYes}
                loading={loading} disabled={loading} dataStyle="expand-right">Yes</Button>
              <Button className="c-btn c-danger plr-30" onClick={() => setToggle(!toggle)}>No</Button>
            </div>
          </CommonModal>
        </div>
      </div>
    </div>
  );
};

export default compose(connect(state => ({ ...state.themeChanger }), null), withRouter)(AdminTable);

